import React, { createContext, useState, useContext } from "react";

const authContext = createContext();

export const ContextApi = ({ children }) => {
  const [filter, setFilter] = useState("Pending");

  return (
    <authContext.Provider
      value={{
        filter,
        setFilter,
      }}
    >
      {children}
    </authContext.Provider>
  );
};

export const useAuth = () => useContext(authContext);
